import { useParams } from 'react-router-dom'
import { format } from 'date-fns'

import { SceneContainer } from '../components/scene/SceneContainer'
import { CalendarEvent } from '../components/calendar/CalendarEvent'
import { useCurrentWorkspace, useCombinedCalendar } from '../store/hooks'
import { useMemo } from 'react'
import { WorkspaceType } from '../lib/db/db.types'

function WorkspaceCalendarEventScreen() {
  const { eventId, workspaceId } = useParams()

  const { events, repeatingEvents } = useCombinedCalendar()
  const { myWorkspaces } = useCurrentWorkspace()

  const { event, repeatingEvent } = useMemo(() => {
    const event = events?.find(
      (e) => e.id === eventId && e.workspaceId === workspaceId,
    )
    const repeatingEvent = repeatingEvents?.find(
      (e) => e.workspaceId === workspaceId && e.id === event?.repeatingEventId,
    )
    return { event, repeatingEvent }
  }, [workspaceId, eventId, events, repeatingEvents])

  const collaborators = useMemo(() => {
    if (event?.workspaceType === WorkspaceType.BUSINESS) {
      const workspace = myWorkspaces?.find((b) => b.id === workspaceId)

      const collaborators = Object.entries(workspace?.collaborators ?? {}).map(
        ([id, collaborator]) => ({
          id,
          name: collaborator.name,
          email: collaborator.email,
        }),
      )

      return collaborators
    } else {
      return []
    }
  }, [event, myWorkspaces, workspaceId])

  if (!eventId) return null
  if (!event) return null
  if (!workspaceId) return null

  return (
    <SceneContainer
      breadcrumbs={[
        { label: 'Calendar', to: `/workspace/${workspaceId}/calendar/` },
        {
          label: event
            ? `${format(new Date(event.date), 'yyyy-MM-dd')} - ${event.name}`
            : 'Not found',
        },
      ]}
    >
      <CalendarEvent
        event={event}
        repeatingEvent={repeatingEvent}
        collaborators={collaborators}
      />
    </SceneContainer>
  )
}

export default WorkspaceCalendarEventScreen
